(function () {
  function initSlider(el) {
    el.setAttribute('data-et-fc-init', '');
    var section = el.closest('.et-fc');

    var options = {
      slidesPerView: parseFloat(el.dataset.slidesMobile) || 1.6,
      spaceBetween: 16,
      breakpoints: {
        750: { slidesPerView: 3 },
        990: { slidesPerView: parseFloat(el.dataset.slidesDesktop) || 4 }
      }
    };

    var prev = section.querySelector('.et-fc__arrow--prev');
    var next = section.querySelector('.et-fc__arrow--next');
    if (prev && next) {
      options.navigation = { prevEl: prev, nextEl: next };
    }

    var scrollbar = section.querySelector('.et-fc__scrollbar');
    if (scrollbar) {
      options.scrollbar = { el: scrollbar, draggable: true };
    }

    new Swiper(el, options);
  }

  function initAll(root) {
    (root || document)
      .querySelectorAll('.et-fc__swiper:not([data-et-fc-init])')
      .forEach(initSlider);
  }

  function whenSwiperReady(callback) {
    if (typeof Swiper !== 'undefined') {
      callback();
      return;
    }
    var attempts = 0;
    var timer = setInterval(function () {
      attempts += 1;
      if (typeof Swiper !== 'undefined') {
        clearInterval(timer);
        callback();
      } else if (attempts > 100) {
        clearInterval(timer);
      }
    }, 50);
  }

  function boot(root) {
    whenSwiperReady(function () {
      initAll(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector('.et-fc__swiper')) {
      boot(event.target);
    }
  });
})();
